
import axios from "axios";
import BaseValues from "./BaseValues";


// NEWARK_HQ instead of OnPrem

export const getTTSSettings = (type) => {

    if(type === "rail"){
        const url = "https://testraildatainternal.njt.gov/api/TTS/getTTS";

        const config = {
            url,
            method: "POST"
        };

        return axios(config).
        then(({data}) => {
            console.log("TTS RAIL DATA", data);

            const records = data.map(d => {
                return {
                    location: d.STATIONNAME,
                    code: d.STATION_2CHAR,
                    value: d.TTS_HOST,
                    group: d.SERVER_GROUP
                };
            })

            return {data: records};
        });
    }
    else {
        // const url = `${BaseValues.BaseURL}/api/TTS/getTTSAssignments`;
        const url = "https://testraildatainternal.njt.gov/api/TTS/getTTSAssignments";

        let modetype = "";

        switch(type){
            case "bus":
                modetype = "BUS";
                break;
            case "lightrail": 
                modetype = "NLR";
                break;
            case "riverline":
                modetype = "RL";
                break;
            default:;
        }

        const data = BaseValues.createFormData({modetype}, true);

        const config = {
            url,
            data,
            method: "POST"
        };

        return axios(config).
        then(({data}) => {
            console.log("TTS NON-RAIL DATA", data);

            const records = data.map(d => {
                return {
                    location: d.location_name,
                    code: d.location,
                    value: (d.host_environment === "AWS") ? "AWS" : "Newark_HQ",
                    group: d.server_group
                };
            });

            return {data: records};
        });
    }

    const promise = new Promise((resolve, reject) => {
        resolve({
            data: [
                {
                    location: "Hoboken",
                    value: "AWS"
                },
                {
                    location: "Newark Penn",
                    value: "AWS"
                },
                {
                    location: "Atlantic City",
                    value: "AWS"
                },
                {
                    location: "Hoboken",
                    value: "AWS"
                },
                {
                    location: "Newark Penn",
                    value: "AWS"
                },
                {
                    location: "Atlantic City",
                    value: "AWS"
                },
                {
                    location: "Hoboken",
                    value: "AWS"
                },
                {
                    location: "Newark Penn",
                    value: "AWS"
                },
                {
                    location: "Atlantic City",
                    value: "AWS"
                }
            ]
        })
    });

    return promise;

    /*
    const config = {
        method: "GET",
        url: "...../getTTSSettings"
    }

    return axios(config)
    .then(({data}) => {
        return {
            data: formatTTS(data)
        }
    });
    */
}

export const formatTTS = (type, data) => {
    const formattedData = [];

    if(data.TTSAssignment && data.TTSAssignment.length > 0){
        console.log("RAW DATA", data);
        data.TTSAssignment.forEach(v => {
            formattedData.push({
                location: v.location,
                value: v.ttsurl,
                group: v.SERVER_GROUP
            });
        });
    }

    return formattedData;
}

export const editTTSSettings = (type, params) => {

    console.log("EDIT TTS PARAMS", params);

    if(type === "rail"){
        const url = "https://testraildatainternal.njt.gov/api/TTS/editTTS";

        const data = BaseValues.createFormData({
            station: params.code,
            ttshost: params.ttsurl,
            servergroup: params.group
        }, true);

        const config = {
            url,
            data,
            method: "POST"
        };

        return axios(config);
    }
    else {
        /*
  /api/TTS/setTTSAssignment 
-- POST, 2 params        
-locationid    (one of the location ids provided by getTTSAssignments)        
-environment   (one of "AWS", "Newark_HQ")                
returns boolean flag to indicate success
        */
        // const url = `${BaseValues.BaseURL}/api/TTS/setTTSAssignment`;
        const url = "https://testraildatainternal.njt.gov/api/TTS/setTTSAssignment";

        const data = BaseValues.createFormData({
            locationid: params.code,
            host_environment: (params.ttsurl === "AWS") ? "AWS" : "Newark_HQ",
            target_environment: "TEST",
            servergroup: params.group
        }, true);

        console.log("RUNNING THE NON-RAIL TTS EDIT");

        const config = {
            url,
            data,
            method: "POST"
        };

        return axios(config);
    }

    const promise = new Promise((resolve, reject) => {
        resolve({data: {}});
    });

    return promise;

    /*
    const data = BaseValues.createFormData(params);

    const config = {
        method: "POST",
        data,
        url: "....../updateTTSSetting"
    }

    return axios(config);
    */
}

export const getGroups = (type) => {

    const url = "https://testraildatainternal.njt.gov/api/TTS/getTTSGroup";

    const bpcs = (type !== "rail");

    console.log("BPCS", bpcs);

    const data = BaseValues.createFormData({
        bpcs
    }, true);

    const config = {
        url,
        data,
        method: "POST"
    };

    return axios(config);
}